/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SideNavComponent } from "./side-nav/side-nav.component";
import { SideNavListComponent } from "./side-nav-list/side-nav-list.component";
import { NavUserComponent } from "./nav-user/nav-user.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { CommoncomponentsModule } from "../../shared/commoncomponents/commoncomponents.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ProfileComponent } from "./profile/profile.component";
import { UserRoutingModule } from "./user-routing.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";

@NgModule({
  declarations: [
    SideNavComponent,
    SideNavListComponent,
    NavUserComponent,
    EditProfileComponent,
    UserProfileComponent,
    ProfileComponent,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    CommoncomponentsModule,
    ReactiveFormsModule,
    FormsModule,
    MatDividerModule,
    RouterModule,
    UserRoutingModule,
    NgxIntlTelInputModule,
  ],
  exports: [SideNavComponent, SideNavListComponent, NavUserComponent],
})
export class UserModule {}
